import { render, staticRenderFns } from "./EquipmentView.vue?vue&type=template&id=565dbfc2&scoped=true"
import script from "./EquipmentView.vue?vue&type=script&lang=js"
export * from "./EquipmentView.vue?vue&type=script&lang=js"
import style0 from "./EquipmentView.vue?vue&type=style&index=0&id=565dbfc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565dbfc2",
  null
  
)

export default component.exports